/* Odmiana liczby terminów używana w sticky pasku i katalogu. */
export function formatTermCount(count) {
  const numericCount = Math.max(
    0,
    Math.trunc(Number(count) || 0)
  )
  const lastTwoDigits = numericCount % 100
  const lastDigit = numericCount % 10

  if (numericCount === 1) {
    return '1 termin'
  }

  if (
    lastDigit >= 2 &&
    lastDigit <= 4 &&
    (lastTwoDigits < 12 || lastTwoDigits > 14)
  ) {
    return `${numericCount} terminy`
  }

  return `${numericCount} terminów`
}

export function formatProgramCount(count) {
  const numericCount = Math.max(
    0,
    Math.trunc(Number(count) || 0)
  )
  const lastTwoDigits = numericCount % 100
  const lastDigit = numericCount % 10

  if (numericCount === 1) {
    return '1 program'
  }

  if (
    lastDigit >= 2 &&
    lastDigit <= 4 &&
    (lastTwoDigits < 12 || lastTwoDigits > 14)
  ) {
    return `${numericCount} programy`
  }

  return `${numericCount} programów`
}
